import alipayLogo from '@/assets/paymentLogos/alipay.png';
import alipayPlusLogo from '@/assets/paymentLogos/alipayPlus.png';
import paynowLogo from '@/assets/paymentLogos/paynow.png';
import weChatPayLogo from '@/assets/paymentLogos/weChatPay.png';
import xnapLogo from '@/assets/paymentLogos/xnap.png';
import thaiQRLogo from '@/assets/paymentLogos/thaiQR.png';
import blank from '@/assets/paymentLogos/blank.png';

import alipayLogoPadded from '@/assets/paymentLogos/padded/alipay.png';
import alipayPlusLogoPadded from '@/assets/paymentLogos/padded/alipayPlus.png';
import paynowLogoPadded from '@/assets/paymentLogos/padded/paynow.png';
import weChatPayLogoPadded from '@/assets/paymentLogos/padded/weChatPay.png';
import xnapLogoPadded from '@/assets/paymentLogos/padded/xnap.png';
import thaiQRLogoPadded from '@/assets/paymentLogos/padded/thaiQR.png';
import blankPadded from '@/assets/paymentLogos/padded/blank.png';

const paymentLogos: Record<string, string> = {
  ALIPAY: alipayLogo,
  ALIPAY_PLUS: alipayPlusLogo,
  PAYNOW: paynowLogo,
  WECHATPAY: weChatPayLogo,
  XNAP: xnapLogo,
  THAIQR: thaiQRLogo,
};

const paddedPaymentLogos: Record<string, string> = {
  ALIPAY: alipayLogoPadded,
  ALIPAY_PLUS: alipayPlusLogoPadded,
  PAYNOW: paynowLogoPadded,
  WECHATPAY: weChatPayLogoPadded,
  XNAP: xnapLogoPadded,
  THAIQR: thaiQRLogoPadded,
};

export const getPaymentLogoImage = (
  qrOrderAgent: string,
): string | undefined => {
  return paymentLogos[qrOrderAgent] || blank;
};

export const getPaddedPaymentLogoImage = (
  qrOrderAgent: string,
): string | undefined => {
  return paddedPaymentLogos[qrOrderAgent] || blankPadded;
};
